module.exports = __webpack_public_path__ + "img/7 Tips for Contributing to Your FSA Infographic.38f36a86.png";